import React from 'react'
import './Card.css'

function Cards(props) {
  return (
    <div>
      <div className='box'>
        <span className={props.work?'pro work':"pro College"}>{props.work?"Work":"College"}</span>
        <img src={props.image} width="70px" height="70px" alt="Logo" className='img' />
        <h3>{props.name}</h3>
        <h3>{props.city}</h3>
        <p>{props.role}</p>
        <div className='btns'>
          <button className='prim'>Message</button>
          <button className='out'>Following</button>
        </div>
        <div className='skills'>
          <h6>Skills</h6>
          {
            <ul>
              {props.skills.map((skill,index)=>(
                <li key={index}>{skill}</li>
              ))}
            </ul>
          }
        </div>
      </div>        
    </div>
  )
}

export default Cards